import { Place } from '../../models/place.interface';

export class SearchedPlaceState {
  searchedPlace: Place | null = null;
}
